<template>
  <div class="inspection-first">
    <div class="form">
      <van-form>
        <van-field
          maxlength="11"
          v-model="form.userPhone"
          label="客户手机"
          placeholder="请输入客户手机"
        />
        <van-field
          readonly
          clickable
          v-model="form.plateNum"
          label="车牌号"
          placeholder="请输入车牌号"
          @click="keyshow = true"
        />
        <van-field
          readonly
          clickable
          :value="form.demandName"
          label="客户需求"
          placeholder="请选择客户需求"
          @click="customerDemandPicker = true"
        />
        <!-- <van-field
          readonly
          clickable
          :value="form.clerk"
          label="技师姓名"
          placeholder="请选择技师"
          @click="showPicker = true"
        /> -->
        <van-field class="test-item" label="检测项目" />
        <van-checkbox-group v-model="form.checkItems" class="check-items">
          <van-row>
            <van-col
              class="items"
              span="8"
              v-for="(item, index) in checkItems"
              :key="index"
            >
              <van-checkbox :name="item.id">
                {{ item.name }}
              </van-checkbox>
            </van-col>
          </van-row>
        </van-checkbox-group>
        <div style="margin: 16px;">
          <van-button type="primary" @click="handleNext">下一步</van-button>
        </div>
      </van-form>
    </div>
    <!-- 技师选择器 -->
    <!-- <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup> -->
    <!-- 客户需求选择器 -->
    <van-popup v-model="customerDemandPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="customerDemandData"
        @confirm="handleCustomerDemand"
        @cancel="customerDemandPicker = false"
      />
    </van-popup>
    <!-- 车牌键盘 -->
    <VehicleKeyBoard
      v-show="keyshow"
      @closeKeyBoard="closeKeyBoard"
      @handlePlateNum="handlePlateNum"
    />
  </div>
</template>

<script>
import { checkItemList } from "@/api/inspection";
import { clerkList } from "@/api/clerk";
import VehicleKeyBoard from "@/components/VehicleKeyBoard.vue";

export default {
  components: {
    VehicleKeyBoard
  },
  data() {
    return {
      userPhone: "",
      plateNum: "",
      clerkList: [],
      columns: [],
      customerDemandData: ["洗车", "保养", "维修"],
      checkItems: [],
      showPicker: false,
      keyshow: false,
      customerDemandPicker: false,
      form: {
        userPhone: "",
        plateNum: "",
        demandName: "",
        customerDemand: "",
        checkItems: []
      }
    };
  },
  mounted() {
    this.handleCheckItemList();
    // this.handleclerkList();
  },
  methods: {
    // 检测项目
    handleCheckItemList() {
      checkItemList().then(res => {
        // console.log("检测项目 :>> ", res);
        this.checkItems = res;
      });
    },
    // 店员列表
    handleclerkList() {
      clerkList().then(res => {
        // console.log("店员列表 :>> ", res);
        this.clerkList = res;
        this.columns = [];
        res.forEach(val => {
          this.columns.push(val.nickname);
        });
      });
    },
    // 下一步
    handleNext() {
      if (!this.handleFormVerify()) {
        return;
      }
      localStorage.setItem("vehicleCheckReport", JSON.stringify(this.form));
      this.$router.push("/inspection/inspectionSecond");
    },
    // 技师选择器
    onConfirm(value, index) {
      this.form.clerk = value;
      this.form.checkUserId = this.clerkList[index].userId;
      this.showPicker = false;
    },
    // 客户需求选择器
    handleCustomerDemand(value, index) {
      this.form.demandName = value;
      this.form.customerDemand = index + 1;
      this.customerDemandPicker = false;
    },
    // 表单校验
    handleFormVerify() {
      if (
        !/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
          this.form.userPhone.trim()
        )
      ) {
        this.$toast("请输入正确的手机号码");
        return false;
      }
      if (this.form.plateNum.trim() === "") {
        this.$toast("请输入车牌号");
        return false;
      }
      if (this.form.demandName.trim() === "") {
        this.$toast("请选择客户需求");
        return false;
      }
      // if (this.form.clerk.trim() === "") {
      //   this.$toast("请选择技师");
      //   return false;
      // }
      if (this.form.checkItems.length === 0) {
        this.$toast("请需要检测的项目");
        return false;
      }
      return true;
    },
    // 车牌键盘完成
    handlePlateNum(plateNum) {
      this.form.plateNum = plateNum;
      if (plateNum.length == 7) {
        this.keyshow = false;
      }
    },
    // 车牌键盘取消
    closeKeyBoard(type) {
      if (!type) {
        this.form.plateNum = "";
        this.keyshow = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.inspection-first {
  .test-item::after {
    border: none;
  }
  .check-items {
    padding: 0px 16px;

    .items {
      padding: 5px 0;
    }
  }
}
</style>
